<template>
  <div>
    <div class="bubble" v-if="message.type===1"
         :class="direction?'bubble-left':'bubble-right'"
         :style="{ backgroundColor: backgroundColor,color:fontColor }">{{ message.content }}
    </div>
    <div class="audio" v-if="message.type===3"
         :class="!direction?'audio-left':'audio-right'"
         :style="{ backgroundColor: backgroundColor,color:fontColor  }"
         @click.prevent.stop="playAudio(message.id, message.body.url)">
      <div v-if="!direction" class="audio-img">
        <img :src="leftCurrentImage" class="audio-img-left"/>
        <span style="">{{ formatAudioDuration(message.body.second) }}</span>
      </div>
      <div v-if="direction" class="audio-img">
        <span v-if="direction">{{ formatAudioDuration(message.body.second) }}</span>
        <img :src="rightCurrentImage" class="audio-img-right"/>
      </div>
    </div>
  </div>
</template>

<script>
import Decimal from "decimal.js";

export default {
  name: "RenderMessage",
  props: {
    message: {
      type: Object,
      required: true,
    },
    direction: {
      type: Boolean,
      required: false,
      default: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: '#FFFFFF'
    },
    fontColor: {
      type: String,
      required: false,
      default: '#333333'
    }
  },
  computed: {
    leftCurrentImage() {
      return `/static/images/2184/chat/audio-left-gif-${this.player.index}.png`;
    },
    rightCurrentImage() {
      return `/static/images/2184/chat/audio-right-gif-${this.player.index}.png`;
    }
  },
  data() {
    return {
      player: {
        id: null,
        audio: null,
        wave: false,
        index: 3,
        intervalId: null,
      },


    }
  },
  methods: {
    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration + '"'
      }
      return ''
    },
    togglePlayback() {//轮播图片
      this.player.intervalId = setInterval(() => {
        this.player.index = (this.player.index % 3) + 1; // 循环索引 1, 2, 3
      }, 300); // 切换一次图片
    },
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
        this.player.index = 3
        clearInterval(this.player.intervalId);
      } else {
        this.togglePlayback()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
          this.player.index = 3
          clearInterval(this.player.intervalId);
        }
        this.player.wave = true
        this.player.id = id
        this.player.audio = audio
      }
    },
  }
}
</script>

<style scoped lang="less">
.bubble {
  font-size: 4vw;
  font-weight: 500;
  padding: 2.9vw 3.2vw;
  max-width: 60vw;
  margin-right: 23px;
  mix-height: 9.3vw;
  word-break: break-all;
}

.bubble-right {
  border-radius: 1vw 6vw 6vw 6vw;
}

.bubble-left {
  border-radius: 6vw 1vw 6vw 6vw;
}

.audio {
  font-size: 4vw;
  font-weight: 500;
  padding: 2.9vw 3.2vw;
  max-width: 60vw;
  margin-right: 23px;
  mix-height: 9.3vw;

  .audio-img {
    align-items: center;
    display: flex;

    .audio-img-left {
      width: 2.6vw;
      margin-right: 2vw;
    }

    .audio-img-right {
      width: 2.6vw;
      margin-left: 2vw;
    }
  }
}

.audio-left {
  border-radius: 1vw 6vw 6vw 6vw;
}

.audio-right {
  border-radius: 6vw 1vw 6vw 6vw;
}


</style>
